const MessagesTypes = {
  SET_TAB: 'SET_TAB',
  SET_MODE: 'SET_MODE',
  SET_TAB_LOADING: 'SET_TAB_LOADING',

  CREATE_MESSAGE_ERROR: 'CREATE_MESSAGE_ERROR',
  CREATE_MESSAGE_REQUEST: 'CREATE_MESSAGE_REQUEST',
  CREATE_MESSAGE_SUCCESS: 'CREATE_MESSAGE_SUCCESS',

  FETCH_MESSAGES_ERROR: 'FETCH_MESSAGES_ERROR',
  FETCH_MESSAGES_SUCCESS: 'FETCH_MESSAGES_SUCCESS',
  ADD_BREEDER_MESSAGE: 'ADD_BREEDER_MESSAGE',

  FETCH_NOTES_SUCCESS: 'FETCH_NOTES_SUCCESS',
  FETCH_NOTES_ERROR: 'FETCH_NOTES_ERROR',

  SET_TAB_NOTES: 'SET_TAB_NOTES',
  UPDATE_NOTE: 'UPDATE_NOTE',
  ADD_NEW_INTERNAL_NOTE: 'ADD_NEW_INTERNAL_NOTE',
  NOTES_TAB_IS_LOADING: 'NOTES_TAB_IS_LOADING',
  TOGGLE_TAB_NOTES_MODE: 'TOGGLE_TAB_NOTES_MODE',
};

export default MessagesTypes;
